import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm8 10a7.92 7.92 0 01-1.69 4.9L7.1 5.69A7.92 7.92 0 0112 4a8 8 0 018 8zM4 12a7.92 7.92 0 011.69-4.9L16.9 18.31A7.92 7.92 0 0112 20a8 8 0 01-8-8z",
			fillRule: "nonzero"
		})
	})
});
export { SvgNo as ReactComponent };
